import { LayoutPrincipal } from '@/components/layout';
import { NoEncontradoPantalla } from '@/pages/NoEncontradoPantalla';
import { PortalPantalla } from '@/pages/PortalPantalla';
import { createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <LayoutPrincipal />,
      children: [
        { index: true, element: <PortalPantalla /> },
        { path: '*', element: <NoEncontradoPantalla /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);
